const LoadingMessage = ({
  selectedBrand,
  selectedAudience,
}: {
  selectedBrand?: string | null;
  selectedAudience?: string | null;
}) => {
  const getMessage = () => {
    if (selectedBrand) {
      return `Gathering ${selectedBrand} videos`;
    }
    if (selectedAudience) {
      return `Finding ${selectedAudience} videos`;
    }
    return "Analyzing competitor videos";
  };

  return (
    <div className="flex flex-col items-center justify-center py-16 px-4">
      <div className="w-8 h-8 border-2 border-blue-200 border-t-blue-600 rounded-full animate-spin mb-4"></div>
      <h3 className="text-lg font-medium text-gray-900 mb-2">{getMessage()}</h3>
      <p className="text-sm text-gray-500 text-center max-w-sm">
        We're scraping and analyzing data from multiple sources.
      </p>
    </div>
  );
};

export default LoadingMessage;
